import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {saveAs} from "file-saver";
import * as XLSX from "xlsx";
import {Workbook} from "exceljs";
interface Rec {
  centreName: string,
  new_admission: number,
  discharge: number,
  follow_up_admission: number,
  follow_up_discharge: number
}

@Component({
  selector: 'app-adc-temp-report',
  templateUrl: './adc-temp-report.component.html',
  styleUrls: ['./adc-temp-report.component.scss']
})
export class AdcTempReportComponent implements OnInit {
  displayedColumns: string[] = ['centreName', 'new_admission', 'discharge', 'follow_up_admission', 'follow_up_discharge'];
  dataSource:MatTableDataSource<Rec>
  isLoading: boolean = false;
  showInactiveCentres = false
  mData: Rec[] = []
  financialYears: string[] = [];
  selectedYear: string = '';

  constructor() {
    this.dataSource = new MatTableDataSource()
  }

  ngOnInit(): void {

    this.financialYears = [
      '2014-2015',
      '2015-2016',
      '2016-2017',
      '2017-2018',
      '2018-2019',
      '2019-2020',
      '2020-2021',
      '2021-2022',
      '2022-2023',
      '2023-2024',
      '2024-2025'
    ];
  }

  get1415() {
    this.mData = []
    this.mData.push(
      {
        centreName: 'AL Ghatla',
        new_admission: 13,
        discharge: 7,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      // {
      //   centreName: 'AL Gurunanak Niwas',
      //   new_admission: 2,
      //   discharge: 2,
      //   follow_up_admission: 0,
      //   follow_up_discharge: 0
      // },
      {
        centreName: 'Total',
        new_admission: 13,
        discharge: 7,
        follow_up_admission: 0,
        follow_up_discharge: 0
      }
    )
  }

  get1516() {
    this.mData = []
    this.mData.push(
      {
        centreName: 'AL Ghatla',
        new_admission: 11,
        discharge: 0,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      // {
      //   centreName: 'AL Gurunanak Niwas',
      //   new_admission: 2,
      //   discharge: 0,
      //   follow_up_admission: 0,
      //   follow_up_discharge: 0
      // },
      {
        centreName: 'Total',
        new_admission: 11,
        discharge: 0,
        follow_up_admission: 0,
        follow_up_discharge: 0
      }
    )
  }

  get1617() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 8,
        discharge: 4,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 21,
        discharge: 22,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Thane',
        new_admission: 30,
        discharge: 17,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'Total',
        new_admission: 59,
        discharge: 44,
        follow_up_admission: 0,
        follow_up_discharge: 0
      }
    );
  }

  get1718() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 5,
        discharge: 7,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Bandra',
        new_admission: 3,
        discharge: 1,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 4,
        discharge: 1,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 22,
        discharge: 21,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 33,
        discharge: 27,
        follow_up_admission: 0,
        follow_up_discharge: 1
      },
      {
        centreName: 'AL Thane',
        new_admission: 33,
        discharge: 32,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'Total',
        new_admission: 100,
        discharge: 89,
        follow_up_admission: 0,
        follow_up_discharge: 1
      }
    );
  }

  get1819() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 8,
        discharge: 6,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Bandra',
        new_admission: 22,
        discharge: 16,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 34,
        discharge: 33,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 13,
        discharge: 16,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 40,
        discharge: 30,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Thane',
        new_admission: 39,
        discharge: 38,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'Total',
        new_admission: 156,
        discharge: 139,
        follow_up_admission: 0,
        follow_up_discharge: 0
      }
    );
  }

  get1920() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 10,
        discharge: 12,
        follow_up_admission: 1,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Bandra',
        new_admission: 46,
        discharge: 42,
        follow_up_admission: 8,
        follow_up_discharge: 7
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 30,
        discharge: 24,
        follow_up_admission: 6,
        follow_up_discharge: 6
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 7,
        discharge: 9,
        follow_up_admission: 4,
        follow_up_discharge: 4
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 26,
        discharge: 33,
        follow_up_admission: 21,
        follow_up_discharge: 21
      },
      {
        centreName: 'AL Thane',
        new_admission: 25,
        discharge: 37,
        follow_up_admission: 16,
        follow_up_discharge: 16
      },
      {
        centreName: 'Total',
        new_admission: 144,
        discharge: 157,
        follow_up_admission: 56,
        follow_up_discharge: 54
      }
    );
  }

  get2021() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 2,
        discharge: 3,
        follow_up_admission: 3,
        follow_up_discharge: 4
      },
      {
        centreName: 'AL Bandra',
        new_admission: 19,
        discharge: 24,
        follow_up_admission: 2,
        follow_up_discharge: 3
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 19,
        discharge: 22,
        follow_up_admission: 8,
        follow_up_discharge: 8
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 7,
        discharge: 6,
        follow_up_admission: 8,
        follow_up_discharge: 5
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 40,
        discharge: 23,
        follow_up_admission: 18,
        follow_up_discharge: 17
      },
      {
        centreName: 'AL Thane',
        new_admission: 0,
        discharge: 0,
        follow_up_admission: 5,
        follow_up_discharge: 5
      },
      {
        centreName: 'Total',
        new_admission: 87,
        discharge: 78,
        follow_up_admission: 44,
        follow_up_discharge: 42
      }
    );
  }

  get2122() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Andheri',
        new_admission: 0,
        discharge: 1,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Bandra',
        new_admission: 20,
        discharge: 20,
        follow_up_admission: 18,
        follow_up_discharge: 17
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 16,
        discharge: 17,
        follow_up_admission: 38,
        follow_up_discharge: 38
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 4,
        discharge: 5,
        follow_up_admission: 16,
        follow_up_discharge: 18
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 63,
        discharge: 61,
        follow_up_admission: 86,
        follow_up_discharge: 84
      },
      {
        centreName: 'AL Pune',
        new_admission: 17,
        discharge: 8,
        follow_up_admission: 3,
        follow_up_discharge: 3
      },
      {
        centreName: 'Total',
        new_admission: 120,
        discharge: 112,
        follow_up_admission: 161,
        follow_up_discharge: 160
      }
    );
  }

  get2223() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Bandra',
        new_admission: 15,
        discharge: 17,
        follow_up_admission: 25,
        follow_up_discharge: 25
      },
      {
        centreName: 'AL Chandigarh',
        new_admission: 30,
        discharge: 13,
        follow_up_admission: 3,
        follow_up_discharge: 3
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 17,
        discharge: 14,
        follow_up_admission: 65,
        follow_up_discharge: 65
      },
      {
        centreName: 'AL Ghatla',
        new_admission: 2,
        discharge: 4,
        follow_up_admission: 7,
        follow_up_discharge: 7
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 56,
        discharge: 58,
        follow_up_admission: 156,
        follow_up_discharge: 152
      },
      {
        centreName: 'AL Manipal',
        new_admission: 32,
        discharge: 23,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Pune',
        new_admission: 17,
        discharge: 19,
        follow_up_admission: 20,
        follow_up_discharge: 20
      },
      {
        centreName: 'AL Thane',
        new_admission: 0,
        discharge: 0,
        follow_up_admission: 1,
        follow_up_discharge: 1
      },
      {
        centreName: 'Total',
        new_admission: 169,
        discharge: 148,
        follow_up_admission: 277,
        follow_up_discharge: 273
      }
    );
  }

  get2324() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Ahmedabad',
        new_admission: 48,
        discharge: 43,
        follow_up_admission: 31,
        follow_up_discharge: 24
      },
      {
        centreName: 'AL Bandra',
        new_admission: 9,
        discharge: 14,
        follow_up_admission: 30,
        follow_up_discharge: 30
      },
      {
        centreName: 'AL Bangalore',
        new_admission: 28,
        discharge: 8,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Chandigarh',
        new_admission: 34,
        discharge: 34,
        follow_up_admission: 32,
        follow_up_discharge: 32
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 21,
        discharge: 18,
        follow_up_admission: 50,
        follow_up_discharge: 49
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 52,
        discharge: 49,
        follow_up_admission: 160,
        follow_up_discharge: 162
      },
      {
        centreName: 'AL Manipal',
        new_admission: 23,
        discharge: 24,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Pune',
        new_admission: 12,
        discharge: 14,
        follow_up_admission: 25,
        follow_up_discharge: 25
      },
      {
        centreName: 'AL Sandu Garden',
        new_admission: 10,
        discharge: 4,
        follow_up_admission: 19,
        follow_up_discharge: 19
      },
      {
        centreName: 'Total',
        new_admission: 237,
        discharge: 208,
        follow_up_admission: 347,
        follow_up_discharge: 341
      }
    );
  }

  get2425() {
    this.mData = [];
    this.mData.push(
      {
        centreName: 'AL Ahmedabad',
        new_admission: 61,
        discharge: 52,
        follow_up_admission: 62,
        follow_up_discharge: 64
      },
      {
        centreName: 'AL Bangalore',
        new_admission: 42,
        discharge: 42,
        follow_up_admission: 3,
        follow_up_discharge: 2
      },
      {
        centreName: 'AL Borivali',
        new_admission: 12,
        discharge: 2,
        follow_up_admission: 4,
        follow_up_discharge: 4
      },
      {
        centreName: 'AL Chandigarh',
        new_admission: 34,
        discharge: 34,
        follow_up_admission: 58,
        follow_up_discharge: 57
      },
      {
        centreName: 'AL Coimbatore',
        new_admission: 25,
        discharge: 12,
        follow_up_admission: 1,
        follow_up_discharge: 1
      },
      {
        centreName: 'AL Diamond Garden',
        new_admission: 14,
        discharge: 16,
        follow_up_admission: 45,
        follow_up_discharge: 42
      },
      {
        centreName: 'AL Gurunanak Niwas',
        new_admission: 43,
        discharge: 51,
        follow_up_admission: 180,
        follow_up_discharge: 182
      },
      {
        centreName: 'AL Manipal',
        new_admission: 26,
        discharge: 23,
        follow_up_admission: 0,
        follow_up_discharge: 0
      },
      {
        centreName: 'AL Pune',
        new_admission: 17,
        discharge: 19,
        follow_up_admission: 9,
        follow_up_discharge: 9
      },
      {
        centreName: 'AL Sandu Garden',
        new_admission: 24,
        discharge: 19,
        follow_up_admission: 15,
        follow_up_discharge: 13
      },
      {
        centreName: 'Total',
        new_admission: 298,
        discharge: 270,
        follow_up_admission: 377,
        follow_up_discharge: 374
      }
    );
  }

  onYearChange(year: string): void {
    console.log('Selected Financial Year:', year);
    this.selectedYear = year;

    // Call the corresponding method based on the selected year
    switch (year) {
      case '2014-2015':
        this.get1415();
        break;
      case '2015-2016':
        this.get1516();
        break;
      case '2016-2017':
        this.get1617();
        break;
      case '2017-2018':
        this.get1718();
        break;
      case '2018-2019':
        this.get1819();
        break;
      case '2019-2020':
        this.get1920();
        break;
      case '2020-2021':
        this.get2021();
        break;
      case '2021-2022':
        this.get2122();
        break;
      case '2022-2023':
        this.get2223();
        break;
      case '2023-2024':
        this.get2324();
        break;
      case '2024-2025':
        this.get2425();
        break;
      default:
        console.warn('No data available for the selected year');
        this.mData = [];
    }

    // Update the data source for the table
    this.dataSource.data = this.mData;
  }

  exportAsXLSX() {
    import('xlsx').then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.mData);
      const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
      this.saveAsExcelFile(excelBuffer, "admission_count_report");
    });
  }
  saveAsExcelFile(data: any[], fileName: string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveBuffer(excelBuffer, fileName);
    let activity = {
      date: new Date().getTime(),
      section: 'Child Report',
      action: 'Download',

      description: `Excel sheet downloaded by`,
      currentIp: localStorage.getItem('currentip')!
    }
  }
  private saveBuffer(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: 'application/octet-stream'});
    saveAs(data, fileName + '.xlsx');
  }

}
